import { render, staticRenderFns } from "./trapdatahistory.vue?vue&type=template&id=23262d3c&scoped=true&"
import script from "./trapdatahistory.vue?vue&type=script&lang=ts&"
export * from "./trapdatahistory.vue?vue&type=script&lang=ts&"
import style0 from "./trapdatahistory.vue?vue&type=style&index=0&id=23262d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23262d3c",
  null
  
)

export default component.exports